module.exports = __webpack_public_path__ + "static/fonts/arial.c28c322.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/arial.eot
// module id = z5ke
// module chunks = 2